// UPDATE: frontend/src/services/authService.js

import api from '../config/api';
import { clearSessionStorageKeys } from '../utils/userScopedStorage';

export const authService = {
  // Login user
  login: async (email, password) => {
    const response = await api.post('/api/users/login', { email, password });

    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('company', JSON.stringify(response.data.company));
    }

    return response.data;
  },

  // Register company (redirect to company service)
  register: async (companyData) => {
    const { companyService } = await import('./companyService');
    return companyService.registerCompany(companyData);
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('company');
    clearSessionStorageKeys(); // the signed-out user's chat and selections (DT-1521)
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Fetch current user from API (fresh data)
  fetchCurrentUser: async () => {
    const response = await api.get('/api/users/me');
    return response.data;
  },

  // Update user profile
  updateProfile: async (userId, profileData) => {
    const response = await api.put(`/api/users/${userId}`, profileData);
    // Update localStorage with new data
    if (response.data.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Get current company
  getCurrentCompany: () => {
    const company = localStorage.getItem('company');
    return company ? JSON.parse(company) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    const company = localStorage.getItem('company');

    return !!(token && user && company);
  }
};